import { render } from "./AddNewQuextField.vue?vue&type=template&id=6b2dac70&scoped=true"
import script from "./AddNewQuextField.vue?vue&type=script&lang=js"
export * from "./AddNewQuextField.vue?vue&type=script&lang=js"

import "./AddNewQuextField.vue?vue&type=style&index=0&id=6b2dac70&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b2dac70"]])

export default __exports__